<!-- start consultation button -->
<!-- Change the State of button based on appointment Start status-->
@if (!appointmentStarted) {
  <app-thin-button class="pl-2 items-center" (click)="$event.stopPropagation(); startConsultation()" [loading$]="loadingNextConsultation$" [disabled]="startConsultIsDisabled">
    <span>{{ 'Start' | localizeText | uppercase }}</span>
    <app-icon icon="mdi-play"></app-icon>
  </app-thin-button>
}


<!-- stop consultation button -->
<!-- Change the State of button based on appointment Start status-->
@if (appointmentStarted) {
  <app-thin-button class="btn btn-grey pl-2" (click)="$event.stopPropagation(); stopConsultation()" [loading$]="loadingStopConsult$" [disabled]="startConsultIsDisabled">
    <span>{{ consultDisplayTime }}</span>
    <app-icon icon="mdi-square" class="text-red pl-1"></app-icon>
  </app-thin-button>
}
